import React, { useEffect, useState } from "react";
import "../../../../assets/CSS/message.css";
import QnaMessageBody from "./QnaMessageBody";
import { useLocation } from "react-router-dom";
import { Participant } from "../../../../VideoChatContents/components/Participants/Participant/Participant.component";
import Participate from "./Participate";
import axios from "axios";

var NoImage =
  "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8cGVyc29ufGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60";

const QnaMsgBox = () => {
  const history = useLocation();
  const { enrolldata, slug, event, from } = history.state;
  const [chatInfo, setChatInfo] = useState();
  const [msgData, setMsgData] = useState([]);
  const [enrollIndex, setEnrollIndex] = useState(0)
  const [sendStatus, setSendStatus] = useState(false)
  const [enrollList, setEnrollList] = useState(enrolldata)
  // const goAnotherChatBox = () => {
  //   setChatInfo(enrollList[])
  // }

  useEffect(() => {


    let enrollArrayLength = enrollList.length


    setChatInfo(enrollList[enrollIndex])

    let selectedUser = enrollList[enrollIndex]

    // alert(sendStatus)
    if (enrollIndex === 0 && enrollIndex < enrollArrayLength) {
    }

    { (selectedUser?.publish_status) === 0 ? setSendStatus(false) : setSendStatus(true) }


  }, [enrollIndex])


  useEffect(() => {

  }, [sendStatus])




  useEffect(() => {
    if (from == 'star') {
      axios.get(`/api/star/registeredList/${slug}`).then((res) => {
        if (res.data.status === 200) {
          setEnrollList(res?.data?.users)
          console.log(res?.data?.users)
        }
      });
    }
  }, [slug])

  return (
    <>
      <div className="container my-2 h-100">
        <div className="d-flex justify-content-between">
          <div className="col-md-3">
            <div className="card message-left py-3 ">
              <h5
                className="text-light fw-bold px-3 mobile-m-text"
                style={{ borderBottom: "0.5px solid #202C33", padding: 5 }}
              >
                All Participate
              </h5>

              <div className="left-text-view">
                {enrollList &&
                  enrollList.map((item, index) => (


                    <Participate
                      item={item}
                      chatInfo={chatInfo}
                      setChatInfo={setChatInfo}
                      setEnrollIndex={setEnrollIndex}
                      enrollIndex={enrollIndex}
                      setHandelSendStatus={setSendStatus}
                      index={index}
                      key={index}
                      timeInterval={event?.time_interval}
                      from={from}
                    />


                  ))}
              </div>
            </div>
          </div>

          <QnaMessageBody chatInfo={chatInfo} SendStatus={sendStatus} from={from} />
        </div>
      </div>
    </>
  );
};

export default QnaMsgBox;
